export enum DiagnosticCategory {
  DEVICE = "DEVICE",
  ENVIRONMENT = "ENVIRONMENT",
  APP = "APP",
  UPDATE = "UPDATES",
  LAYOUT = "LAYOUT",
  SESSION = "SESSION",
  PERMISSION = "PERMISSION",
  NETWORK = "NETWORK",
  PURCHASES = "PURCHASES",
  LOCALE = "LOCALE",
}

export enum DiagnosticStatus {
  OK = "OK",
  WARNING = "WARNING",
  ERROR = "ERROR",
}

export type DiagnosticItem = {
  id: string;
  name: string;
  value: string;
  status: DiagnosticStatus;
};

export type DiagnosticRun = {
  [DiagnosticCategory.DEVICE]: DiagnosticItem[];
  [DiagnosticCategory.ENVIRONMENT]: DiagnosticItem[];
  [DiagnosticCategory.APP]: DiagnosticItem[];
  [DiagnosticCategory.UPDATE]: DiagnosticItem[];
  [DiagnosticCategory.PURCHASES]: DiagnosticItem[];
  [DiagnosticCategory.LAYOUT]: DiagnosticItem[];
  [DiagnosticCategory.SESSION]: DiagnosticItem[];
  [DiagnosticCategory.PERMISSION]: DiagnosticItem[];
  [DiagnosticCategory.NETWORK]: DiagnosticItem[];
  [DiagnosticCategory.LOCALE]: DiagnosticItem[];
};
